import { render, staticRenderFns } from "./AnswerBox.vue?vue&type=template&id=3757b9ef&scoped=true"
import script from "./AnswerBox.vue?vue&type=script&lang=js"
export * from "./AnswerBox.vue?vue&type=script&lang=js"
import style0 from "./AnswerBox.vue?vue&type=style&index=0&id=3757b9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757b9ef",
  null
  
)

export default component.exports